import React, { Component } from 'react';

export class ThankYou extends Component {

    justreload = () => {
        //I tried.. and got annoyed.... so settling to just this!
        window.location.reload();
    }

    goHome = () => {
        window.open("https://sla.ny.gov/","_self");
    }

    getMessage = () => {
        if (this.props.submitSuccess === true) {
            return (<h3 className="friendly">You have successfully submitted your complaint. We will begin the process and determine appropriate actions to be taken.Thank you for registering your complaint with the <b>New York State Liquor Authority</b>.</h3>);
        }
        else {
            return(<h3 className="friendly">We're very sorry. We were not able to register your complaint with <br />the <b>New York State Liquor Authority</b>.</h3>);
        }
    }

    render() {
        return (
            <div className="container">
                <div className="row mt-5">
                    <div className="jumbotron centralize">{this.getMessage()}</div>
                </div>
                <div className="centralize spacer">
                    <button className="btn home" onClick={this.goHome}><span className="glyphicon glyphicon-home" /> Go Back to NYS SLA </button>  <button className="btn btn-sla-primary" onClick={this.justreload}>File a New Complaint</button>
                </div>
            </div>
        );
    }
}

export default ThankYou;



// WEBPACK FOOTER //
// ./src/components/ThankYou.js